import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { paymentApi } from 'api/app/payment';
import { PaymentMethodCode } from 'api/app/types';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { RootState } from 'shared/redux/store';
import { getUniqueCartId } from 'shared/utils/common';
import { AddToCartFormValues } from '../ItemDetails/types';
import { CartState } from './types';
import { SuggestServiceResponse } from '../../../../api/app/types';

const initialState: CartState = {
  payment_method: 'cash_by_recipient',
  items: [],
  suggest_services: [],
};

export const cartSlice = createSlice({
  name: 'cartSlice',
  initialState,
  reducers: {
    setPaymentMethod(state, action: PayloadAction<PaymentMethodCode>) {
      state.payment_method = action.payload;
    },
    setAhaPromo(state, action: PayloadAction<string | undefined>) {
      state.aha_promo = action.payload;
    },
    setSuggestService(state, action: PayloadAction<SuggestServiceResponse[]>) {
      state.suggest_services = action.payload;
    },

    addToCart(state, action: PayloadAction<AddToCartFormValues>) {
      state.items = [
        ...state.items,
        {
          ...action.payload,
          cart_id: getUniqueCartId(action.payload),
        },
      ];
    },
    updateToCart(
      state,
      action: PayloadAction<{
        id: AddToCartFormValues['cart_id'];
        values: Partial<Omit<AddToCartFormValues, 'cart_id'>>;
      }>
    ) {
      const {
        id,
        values: { num = 0, ...data },
      } = action.payload;
      const updatedItems = state.items.map((item) =>
        item.cart_id === id
          ? {
              ...item,
              ...data,
              num,
            }
          : item
      );
      state.items = [...updatedItems];
    },
    removeFromCart(
      state,
      action: PayloadAction<AddToCartFormValues['cart_id']>
    ) {
      const filteredItems = state.items.filter(
        (item) => item.cart_id !== action.payload
      );
      state.items = [...filteredItems];
    },
    emptyCart(state) {
      state.items = [];
    },
    setUseEInvoice(state, action: PayloadAction<boolean>) {
      state.use_e_invoice = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // .addMatcher(
      //   paymentApi.endpoints.getPaymentMethods.matchFulfilled,
      //   (state, action: PayloadAction<PaymentMethod[] | null>) => {
      //     state.payment_method = action.payload
      //       ? action.payload[0].code
      //       : 'cash_by_recipient';
      //   }
      // )
      .addMatcher(
        paymentApi.endpoints.getPaymentMethods.matchRejected,
        (state, action) => {
          state.payment_method = 'cash_by_recipient';
        }
      );
    // .addMatcher(
    //   userApi.endpoints.getUserProfile.matchFulfilled,
    //   (state, action: PayloadAction<User | null>) => {
    //     state.service_id =
    //       action.payload &&
    //       action.payload.city_id &&
    //       action.payload.city_id[0]
    //         ? `${action.payload.city_id[0]}-BIKE`
    //         : '';
    //   }
    // );
  },
});

export const cartReducer = persistReducer(
  {
    key: 'cart',
    storage,
    whitelist: ['service_id', 'payment_method', 'items'],
  },
  cartSlice.reducer
);

// SELECTOR
export const selectPaymentMethod = (state: RootState) =>
  state.cartSlice.payment_method;
export const selectCartItems = (state: RootState) => state.cartSlice.items;
export const selectAhaPromo = (state: RootState) => state.cartSlice.aha_promo;
export const selectUseEInvoice = (state: RootState) =>
  state.cartSlice.use_e_invoice;
export const selectSuggestServices = (state: RootState) =>
  state.cartSlice.suggest_services;
